export default "__VITE_ASSET__frrU2Dsi__"